"use client";
import Marquee from "react-fast-marquee";
import { useTranslation } from "@/app/i18n/i18n-client";

export default function MarqueeComponent({ locale }) {
  const { t } = useTranslation(locale, "marquee");
  const marQueeItems = [
    {
      id: 1,
      href: "#",
      text: "marqueeItem1",
      icon: "fas fa-chart-line",
    },
    {
      id: 2,
      href: "#",
      text: "marqueeItem2",
      icon: "fas fa-laptop-code",
    },
    {
      id: 3,
      href: "#",
      text: "marqueeItem3",
      icon: "fas fa-search",
    },
    {
      id: 4,
      href: "#",
      text: "marqueeItem4",
      icon: "fas fa-map-marker-alt",
    },
    {
      id: 5,
      href: "#",
      text: "marqueeItem5",
      icon: "fas fa-paint-brush",
    },
    {
      id: 6,
      href: "#",
      text: "marqueeItem6",
      icon: "fas fa-analytics",
    },
  ];
  

  return (
    <div className="container-fluid p-0 overflow-hidden">
      <div className="slider__marquee clearfix marquee-wrap">
        <div className="marquee_mode marquee__group">
          <Marquee pauseOnHover={true}>
            {marQueeItems.map((elm) => (
              <h6 key={elm.id} className="item m-item">
                <a href={elm.href}>
                  <i className={elm.icon}></i> {t(`text.${elm.text}`)}
                </a>
              </h6>
            ))}
          </Marquee>
        </div>
      </div>
    </div>
  );
}